import React, { useState, useEffect} from "react";
import Slider from "@mui/material/Slider";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Container, Row, Col } from "react-bootstrap";
import AudioPlayer from "react-h5-audio-player";
import { MdOutlineReplay } from "react-icons/md";
import "react-h5-audio-player/lib/styles.css";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormGroup from "@mui/material/FormGroup";


import "./style.css";
import useBatchStudyInfo from "../../../api-definition/useBatchStudyInfo";
import { getCookie } from "../../../utils/cookieUtils"; 

const Form = (props) => {
  const username = getCookie("X-Spl-Username-Header");
  const [value, setValue] = useState(50);
  const [checked, setChecked] = useState(false);
  const [checkedJunk, setJunkChecked] = useState(false);
  const [checkedPartial, setPartialChecked] = useState(false);
  const [checkedLengthened, setLengthenedCheck] = useState(false);
  const [checkedTranscript, setTranscriptChecked] = useState(false);
  const [text, setText] = useState("");
  const [data, setData] = useState([]);
  const [oldfn, setOldfn] = useState(0);
  const [fileDownloaded, setFileDownloaded] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [clearPage, setClearPage] = useState(false);

  const {
    batchName,
    batchType,
    batchId,
    studyName,
    fileNumber,
    leftLevel,
    rightLevel,
    low_rating_options,
    rating_error_level,
    rating_severity,
    instruction,
    audio_file_url,
    audio_file_id,
    audio_transcription,
    total_file_count,
    total_rated_file_count,
    updateId,
    backId,
  } = useBatchStudyInfo(props);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOptionSelect = (event) => {
    const option = event.target.value;
    setSelectedOptions((prevSelectedOptions) =>
      prevSelectedOptions.includes(option)
        ? prevSelectedOptions.filter((item) => item !== option)
        : [...prevSelectedOptions, option]
    );
    // setSelectedOptions(event.target.value);
  };

  const handleJunkCheckboxChange = (event) => {
    setJunkChecked(event.target.checked);
  };

  const handlePartialCheckboxChange = (event) => {
    setPartialChecked(event.target.checked);
  };

  const handleLengthenedCheckboxChange = (event) => {
    setLengthenedCheck(event.target.checked);
  };

  const handleTranscriptCheckboxChange = (event) => {
    setTranscriptChecked(event.target.checked);
  };

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  const [svalue, ssetValue] = useState(1);

  const changeValue = (event, value) => {
    ssetValue(value);
  };

  const getText = (svalu) => `${svalue}`;

  const customMarks = Object.keys(rating_severity).map((key) => ({
    value: parseInt(key),
    label: rating_severity[key],
    style: {
      backgroundColor: key === "1" ? "red" : key === "2" ? "orange" : "gray",
      width: "2px",
    },
  }));

  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000); // update every second

    return () => clearInterval(interval); // cleanup interval on unmount
  }, []);

  const resetForm = () => {
    setChecked(false);
    setJunkChecked(false);
    setPartialChecked(false);
    setTranscriptChecked(false);
    setLengthenedCheck(false);
    setText("");
    setData([]);
    setOldfn(0);
    setFileDownloaded(false);
    setSelectedOptions([]); // Reset the selected options state
    ssetValue(1);
    setPlayCount(0);
    if (total_rated_file_count + 1 === total_file_count) {
      setClearPage(true);
    }
  };

  const handleContinueButton = () => {
    const data = {
      audio_file_id: audio_file_id,
      batch_id: batchId,
      rating_severity_value: svalue,
      rating_category: rating_severity[svalue],
      low_rating_options: selectedOptions,
      replays: playCount,
      junk_audio: checkedJunk,
      partial_audio: checkedPartial,
      lengthened: checkedLengthened,
      transcript_mismatch: checkedTranscript,
      comments: text,
      time_of_rating: currentTime.toLocaleTimeString(),
    };
    console.log(data);
    fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/user-audio`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Spl-Username-Header": username
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        // Handle successful response
        console.log(response);
        resetForm();
      })
      .catch((error) => {
        // Handle error
        console.error("Excepted!");
      });
    updateId();
  };

  const handleBackButton = () => {
    backId();
  };

  const [playCount, setPlayCount] = useState(0);
  const [controlsEnabled, setControlsEnabled] = useState(true);

  const handleEnded = (playCount) => {
    setControlsEnabled(false);
    document
      .getElementsByClassName("rhap_main-controls")[0]
      .style.setProperty("display", "none");
  };

  const handlePlay = () => {
    if (playCount < 5) {
      const audioPlayer = document.getElementsByClassName("rhap_container")[0];
      audioPlayer.getElementsByTagName("audio")[0].play();
      setPlayCount(playCount + 1);
      props.onReplayCountChange(playCount + 1);
      if (playCount === 3) {
        setControlsEnabled(false);
      }
    }
  };

  return (
    <form>
      
      {clearPage ? (
            <div style={{ color: "#000E54", textAlign: "center"}}>
              <h3>Thank you. You've rated all files in this batch.</h3>
            </div>        
      ) : (
      <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center"}}>
        <Box className="details" >
          <div className="audiocontent">
            <label style={{ flex: "left" }}>
              <div style={{ textAlign: "left" }}>
                <b>{"Batch Name : "}</b> {batchName}
              </div>
              <div style={{ textAlign: "left" }}>
                <b>{"Study Name : "}</b> {studyName}
              </div>
              <div style={{ textAlign: "left" }}>
                <b>{"Replays : "}</b> {playCount} {"/ 5"}
              </div>
              <div style={{ textAlign: "left" }}>
                {/* <b>{"File Number : "}</b> {fileNumber} {"/"} {total_file_count} */}
                <b>{"File Number : "}</b> {total_rated_file_count + 1} {"/"} {total_file_count}
              </div>
              <div style={{ textAlign: "left" }}>
                <b>{"Batch Instruction : "}</b> {instruction}
              </div>
            </label>
          </div>
        </Box>

        <Box>
          <Container>
            <Row>
              <Col>
                <div class="p-grid-container">
                  <div className="audioplayer">
                    <AudioPlayer                  
                      src={`${process.env.REACT_APP_API_URL}/percept_db/v1/download-wav-file?file_path=` + audio_file_url + '&batch_id=' + batchId + '&user=' + username}
                      autoPlayAfterSrcChange={true}
                      onEnded={handleEnded}
                      showJumpControls={controlsEnabled}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <Container>
          {/* <div className="replay">
              <MdOutlineReplay
              onClick={handlePlay}
              disabled={playCount >= 5}
            />
          </div> */}
          <label className="audiocontents">
            <b style={{ textAlign: "center" }}>{audio_transcription}</b>
          </label>
          </Container>
        </Box>
      </div>

      <Row>
        <Box display="flex" flexDirection="column" m={7}>
          <div style={{ width: "100%", float: "left"  }}>
            <div style={{ display: "flex", alignItems: "center" , justifyContent: "center"}}>
              <div style={{ marginRight: "30px", fontSize: "18px", paddingBottom: "30px"}}>
                <p>{leftLevel}</p>
              </div>
              <div style={{ marginRight: "10px", paddingTop: "35px", paddingBottom: "50px"}}>
                <Slider
                  style={{ width: 900, paddingTop: 0 }}
                  min={1}
                  max={5}
                  step={1}
                  value={svalue}
                  marks={customMarks}
                  onChange={changeValue}
                  getAriaValueText={getText}
                  classes={{
                    mark: "slider-mark",
                    markLabel: "slider-mark-label",
                  }}
                />
              </div>
              <div style={{ marginLeft: "30px", fontSize: "18px" ,paddingBottom: "30px" }}>
                <p>{rightLevel}</p>
              </div>
            </div>
            <style>
              {`
                .slider-mark {
                  width: 2px;
                  margin-top: -5px;
                  margin-left: -1px;
                }
                .slider-mark-label {
                  font-size: 21px;
                  // font-weight: bold;
                  margin-top: 3px;
                  margin-left: -15px;
                  color: black;
                  white-space: initial;
                  display: block;
                  overflow-wrap: break-word;
                  overflow: hidden;
                  border-radius: 10px;
                  // padding-top: 5px;
                  // padding-bottom: 5px;
                  padding: 5px;
                  width: 150px;
                  height: 120px;
                  border: 10px solid;
                  // border-width: thick;
                  background-color: #F2F2F2;
                  cursor: pointer;
                }
                .slider-mark-label[data-index="0"] {
                  border-color: #B63557; //PINK-RED
                }
                
                .slider-mark-label[data-index="1"] {
                  border-color: #D84C3D; //RED-ORANGE
                } 
                .slider-mark-label[data-index="2"] {
                  border-color: #F76900; //ORANGE
                }
                
                .slider-mark-label[data-index="3"] {
                  border-color: #FABE22; //YELLOW-ORANGE

                }
                .slider-mark-label[data-index="4"] {
                  border-color: #40BD72; //GREEN

                }
                
                .slider-mark-label[data-index="5"] {
                  border-color: #AADC31; // LIME-GREEN

                }
                .slider-mark-label[data-index="6"] {
                  border-color: #40BD72;
                }
                
                ${
                  customMarks.map(
                  (mark) => `
                    .slider-mark[data-index="${mark.value}"] .slider-mark-label {
                      background-color: ${mark.style.backgroundColor};
                      width: ${mark.style.width};
                    }
                  `
                )}
              `}
            </style>
          </div>
        </Box>
      </Row>
  
      <FormControl>
        <Row>
          <Box display="flex" flexDirection="row" >
            <Box m={5} paddingLeft="10px" flex={2}>
              <p style={{ textAlign: "left" }}>
              {/* <label style={{ textAlign: "left" }}>Deletion / Substitution / Distortion Subtype:</label>
                  <Select
                    multiple
                    value={selectedOptions}
                    onChange={handleOptionSelect}
                    inputProps={{
                      name: "low_rating_options",
                    }}
                    style={{
                      width: "250px",
                      maxWidth: "100%",
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      backgroundColor: "#f7f7f7",
                      overflow: "auto",
                    }}
                    MenuProps={{
                      getContentAnchorEl: null,
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                      },
                    }}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {low_rating_options.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        <Checkbox
                          checked={selectedOptions.includes(option)}
                          color="primary"
                        />
                        {option}
                      </MenuItem>
                    ))}
                  </Select> */}
                  <b style={{ textAlign: "left" }}>Deletion / Substitution / Distortion Subtype:</b>
                  <FormGroup>
                    {low_rating_options.map((option, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            checked={selectedOptions.includes(option)}
                            onChange={handleOptionSelect}
                            value={option}
                          />
                        }
                        label={option}
                      />
                    ))}
                  </FormGroup>
              </p>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              m={5}
              paddingLeft="30px"
              flex={1}
            >

              <Button
                  onClick={handleContinueButton}
                  variant="contained"
                  style={{
                    width: "175px",
                    height: "50px",
                    marginTop: "20px",
                    backgroundColor: (((batchType === 's' || batchType === 'z') && svalue <= 3) || (batchType == 'r' && svalue ===1)) && (selectedOptions.length === 0 && !checkedJunk && !checkedPartial && !checkedTranscript)
                                      ? "rgba(0, 14, 84, 0.5)" : "#000E54",color: "#fff", // Text color
                  }}
                  disabled={
                    (((batchType === 's' || batchType === 'z') && svalue <= 3) || (batchType == 'r' && svalue ===1))
                     &&
                    (selectedOptions.length === 0 && !checkedJunk && !checkedPartial && !checkedTranscript)
                  }
                >
                  Continue
                </Button>
                <div className="replay">
                  <MdOutlineReplay
                  onClick={handlePlay}
                  disabled={playCount >= 5}
                />
                </div>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              m={5}
              paddingLeft="50px"
              flex={2}
            >
              <span ></span>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedLengthened}
                    onChange={handleLengthenedCheckboxChange}
                  />
                }
                style={{ display: "flex", justifyContent: "flex-end" }}
                label={<span style={{ fontWeight: "bold" }}>Lengthened</span>}
              />
              <p style={{ display: "flex", gap: "10px" }}>
              <TextField
                placeholder="Comments"
                multiline
                rows={3}
                style={{
                  backgroundColor: "#F5F5F5",
                  width: "300px",
                  height: "100px",
                }}
                value={text}
                onChange={handleTextChange}
              />
              </p>
              <label style={{ textAlign: "left", fontWeight: "bold"}}>Audio File Feedback:</label>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedJunk}
                    onChange={handleJunkCheckboxChange}
                  />
                }
                label={<span style={{ whiteSpace: "nowrap" }}>Junk (Unusable) Audio</span>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedPartial}
                    onChange={handlePartialCheckboxChange}
                  />
                }
                label={<span style={{ whiteSpace: "nowrap" }}>Partial Audio</span>}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checkedTranscript}
                    onChange={handleTranscriptCheckboxChange}
                  />
                }
                label={<span style={{ whiteSpace: "nowrap" }}>Transcript mismatch</span>}
              />
            </Box>
          </Box>
        </Row>
      </FormControl></div>
      )}
    </form>
  );
};

export default Form;
